<div class="copo-container">
	<div class="copo-section">
		<div class="copo-section-body copo-grid">
			<div class="copo-grid-row">
				<div class="copo-grid-row-column-2" *ngIf="coNbr">
					<div class="card-content-info">
						<div class="card-content-label" translate>need4steel.wizard.header.customer-order-number</div>
						<div class="card-content-value" [matTooltip]="coNbr">
							{{coNbr}}
						</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2" [ngClass]="{'hide-soldto': soldtoShiptoList && getSoldToBocListSize(soldtoShiptoList) < 2 }">
					<!-- SoldTo -->
					<div class="card-content-info">
						<div class="card-content-label" translate>need4steel.wizard.header.soldto</div>
						<div class="card-content-value" [matTooltip]="soldto ? soldto : UNDERSCORE">
							{{ soldto ? soldto : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2">
					<!-- ShipTo -->
					<div class="card-content-info">
						<div class="card-content-label" translate>need4steel.wizard.header.shipto</div>
						<div class="card-content-value" [matTooltip]="shipto ? shipto : UNDERSCORE">
							{{ shipto ? shipto : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2" *ngIf="showEndUser">
					<!-- End User -->
					<div class="card-content-info">
						<div class="card-content-label" translate>eoffer.create.enduser</div>
						<div class="card-content-value" [matTooltip]="enduser ? enduser : UNDERSCORE">
							{{ enduser ? enduser : UNDERSCORE }}</div>
					</div>
				</div>
				<!-- Transport Mode (readonly, shown only when mill is in allowed list) -->
				<div class="copo-grid-row-column-2" *ngIf="isShipmentSelectionEnabled">
					<div class="card-content-info">
						<div class="card-content-label" translate>transport.mode</div>
						<div class="card-content-value">
							<span translate>{{ getTransportModeTrKey() }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="copo-grid-row">
				<div class="copo-grid-row-column-2">
					<!-- Mill -->
					<div class="copo-form-field">
						<div class="card-content-label" translate>need4steel.wizard.header.mill</div>
						<div class="card-content-value" [matTooltip]="form.getFormMill().value ? form.getFormMill().value: UNDERSCORE">
							{{ form.getFormMill().value ? form.getFormMill().value : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2">
					<!-- Delivery Date -->
					<div class="copo-form-field">
						<div class="card-content-label" translate>need4steel.wizard.header.delivery.date</div>
						<div class="card-content-value"
							[matTooltip]="form.getFormDeliveryDate().value ? form.getFormDeliveryDate().value : UNDERSCORE">
							{{ form.getFormDeliveryDate().value ? form.getFormDeliveryDate().value : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2" *ngIf="hasExchangeRateToDisplay()">
					<!-- Exchange Rate -->
					<div class="card-content-info">
						<div class="card-content-label" translate>need4steel.wizard.exchange-rate.rate</div>
						<div class="card-content-value"
							[style.transition]="'background-color 1s ease-in-out'"
							[style.background-color]="shouldHighlightExchangeRate() ? '#fff3a3' : 'transparent'">
							1 EUR = {{ getExchangeRateDisplayValue() }} {{ getExchangeRateDisplayCurrency() }}
						</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2" *ngIf="hasExchangeRateToDisplay()">
					<!-- Reference Date -->
					<div class="card-content-info">
						<div class="card-content-label" translate>need4steel.wizard.exchange-rate.reference-date</div>
						<div class="card-content-value"
							[style.transition]="'background-color 1s ease-in-out'"
							[style.background-color]="shouldHighlightExchangeRate() ? '#fff3a3' : 'transparent'">
							{{ getExchangeRateDisplayReferenceDate() || UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="copo-grid-row-column-2" *ngFor="let emptyColumn of getSummaryEmptyColumns()">
					<!-- empty column to keep both rows aligned -->
				</div>
			</div>
		</div>
	</div>
</div>
<div class="grey-block">
	<div class="grid-column-one-full">
		<div *ngIf="largeScreen">
			<div class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index">
				<div class="card-header copo-dark-theme copo-dark-theme-padding">
					<div class="card-container-column step-product-spec-field field-padding">
						<mat-label class="card-header-label item-number-width"
							translate>need4steel.wizard.stepper.product.itemnumber</mat-label>
						<div class="item-number-width"><span> {{ i+1 | number: '3.' }}</span></div>
					</div>
					<div class="card-container-column step-product-spec-field field-padding">
						<div class="card-header-label" translate>need4steel.wizard.stepper.product.steelgrade</div>
						<div class="input-field">{{ getControl(i, 'steelGrade').value }}</div>
					</div>
					<div class="card-container-column step-product-spec-field field-padding">
						<div class="card-header-label" translate>need4steel.wizard.stepper.product.thickness</div>
						<div class="input-field">{{ getControl(i, 'thickness').value }}</div>
					</div>
					<div class="card-container-column step-product-spec-field field-padding">
						<div class="card-header-label" translate>need4steel.wizard.stepper.product.width</div>
						<div class="input-field">{{ getControl(i, 'width').value }}</div>
					</div>
					<ng-container
						*ngIf="getWeightType() === 'maxNetWeightValue' || getWeightType() === 'maxWeightPerWidthUnitValue'">
						<div class="card-container-column step-product-spec-field field-padding-weight">
							<div class="card-header-label field-width" translate>
								{{ getWeightType() === 'maxNetWeightValue' ?
								'need4steel.wizard.stepper.product.coilweight' :
								'need4steel.wizard.product.specific.weight' }}
							</div>
							<div class="input-field">
								{{ getWeightType() === 'maxNetWeightValue' ? getControl(i, 'maxCoilWeight').value :
								getControl(i, 'maxSpecificWeight').value }}
							</div>
						</div>
					</ng-container>
					<div class="card-container-column step-product-spec-field field-padding-coil">
						<div class="placeholder" translate>need4steel.wizard.stepper.product.coil</div>
						<div class="input-field">{{ getControl(i, 'coil').value }}</div>
					</div>
					<div class="card-container-column">
						<div class="card-header-label total-weight-col" translate>
							need4steel.wizard.stepper.product.total.weight
							<span class="overflow-wrap">&nbsp;&nbsp;{{getTotalWeightDecimal(i)| copoNumber:'amount':''}}&nbsp;t</span>
						</div>
					</div>
				</div>
				<!-- 2nd row -->
				<div class="card-content">
					<div [ngClass]="(maxSpecCoilWeightOptionAvailable ? 'card-content-left-1': 'card-content-left')">
						<ng-container *ngFor="let variable of getVariableFieldLength(i); let j=index">
							<div class="copo-content-product card-header-double-span" *ngIf="!isVariableSpecificField(variable.field)">
								<span class="card-content-label">{{getFieldLabel(variable.field)}}</span>
								<div class="input-field">
								<ng-container *ngIf="getVariableListValue(i, variable.field) !== ''; else noneValue">
										{{ getVariableListValue(i, variable.field) }}
									</ng-container>
									<ng-template #noneValue>
										<ng-container *ngIf="variable.field === 'additionalTest'">
											<span translate>fastlane.itemlist.product.coil_axis.default</span>
										</ng-container>
									</ng-template>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="card-content-right price-info-block">
						<div class="copo-price-block">
							<span class="copo-underscore">{{getTotalPrice(i) }}</span>
							<b><span translate>need4steel-product-details.effectivedelivered</span></b>
						</div>
						<div *ngIf="hasExchangeRateToDisplay() && getPriceNumber(i) > 0" class="estimated-price-line">
							<i><span translate>need4steel.wizard.estimated</span> {{ getEstimatedPrice(i) }}/t <span translate>need4steel-summary-details.effectivedelivered</span></i>
						</div>
					</div>
				</div>
				<mat-divider class="mat-divider"></mat-divider>
			</div>
		</div>
		<div *ngIf="!largeScreen">
			<div class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index">
				<div class="card-header copo-dark-theme">
					<div>
						<div class="card-header-label item-number-width" translate>
							need4steel.wizard.stepper.product.itemnumber
						</div>
						<div class="item-number-width"> <span> {{ i+1 | number: '3.' }}</span></div>
					</div>
					<div class="card-container-column">
						<div class="card-header-label" translate>need4steel.wizard.stepper.product.steelgrade</div>
						<div class="input-field">{{ getControl(i, 'steelGrade').value }}</div>
					</div>
					<div class="card-container-column total-weight-width">
						<div class="card-header-label total-weight-col" translate>
							need4steel.wizard.stepper.product.total.weight
							<span class="overflow-wrap">&nbsp;&nbsp;{{getTotalWeightDecimal(i)}}&nbsp;t</span>
						</div>
					</div>
				</div>
				<div class="card-content-mobile">
					<div class="content-grid-mobile">
						<div class="card-container-column step-product-spec-field field-padding">
							<div class="card-content-label-1 field-width" translate>
								need4steel.wizard.stepper.product.thickness
							</div>
							<div class="input-field">{{ getControl(i, 'thickness').value }}</div>
						</div>
						<div class="card-container-column step-product-spec-field">
							<div class="card-content-label-1 field-width" translate>
								need4steel.wizard.stepper.product.width
							</div>
							<div class="input-field">{{ getControl(i, 'width').value }}</div>
						</div>
						<ng-container
							*ngIf="getWeightType() === 'maxNetWeightValue' || getWeightType() === 'maxWeightPerWidthUnitValue'">
							<div class="card-container-column step-product-spec-field field-padding-weight">
								<div class="card-content-label-1 field-width" translate>
									{{ getWeightType() === 'maxNetWeightValue' ?
									'need4steel.wizard.stepper.product.coilweight' :
									'need4steel.wizard.product.specific.weight' }}
								</div>
								<div class="input-field">
									{{ getWeightType() === 'maxNetWeightValue' ? getControl(i, 'maxCoilWeight').value :
									getControl(i, 'maxSpecificWeight').value }}
								</div>
							</div>
						</ng-container>
						<div class="card-container-column step-product-spec-field mobile-coil">
							<div class="placeholder card-content-label-1" translate>
								need4steel.wizard.stepper.product.coil</div>
							<div class="input-field">{{ getControl(i, 'coil').value }}</div>
						</div>
					</div>
					<!-- 2nd row -->
					<div class="sub-content">
						<div class="card-content-left">
							<ng-container *ngFor="let variable of getVariableFieldLength(i); let j=index">
								<div class="copo-content-product card-header-double-span" *ngIf="!isVariableSpecificField(variable.field)">
									<span class="card-content-label">{{getFieldLabel(variable.field)}}</span>
									<div class="input-field">
										<ng-container *ngIf="getVariableListValue(i, variable.field) !== ''; else noneValue">
											{{ getVariableListValue(i, variable.field) }}
										</ng-container>
										<ng-template #noneValue>
											<ng-container *ngIf="variable.field === 'additionalTest'">
												<span translate>fastlane.itemlist.product.coil_axis.default</span>
											</ng-container>
										</ng-template>
									</div>
								</div>
							</ng-container>
						</div>
						<div class="card-content-right price-info-block">
							<div class="copo-price-block">
								<span class="copo-underscore">{{getTotalPrice(i) }}</span>
								<b><span translate>need4steel-product-details.effectivedelivered</span></b>
							</div>
							<div *ngIf="hasExchangeRateToDisplay() && getPriceNumber(i) > 0" class="estimated-price-line">
								<i><span translate>need4steel.wizard.estimated</span> {{ getEstimatedPrice(i) }}/t <span translate>need4steel-summary-details.effectivedelivered</span></i>
							</div>
						</div>
					</div>
				</div>
				<mat-divider class="mat-divider"></mat-divider>
			</div>
		</div>
	</div>
</div>